import { render, staticRenderFns } from "./ExcelLR.vue?vue&type=template&id=202c53a0&scoped=true&"
import script from "./ExcelLR.vue?vue&type=script&lang=js&"
export * from "./ExcelLR.vue?vue&type=script&lang=js&"
import style0 from "./ExcelLR.vue?vue&type=style&index=0&id=202c53a0&scoped=true&lang=css&"
import style1 from "./ExcelLR.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c53a0",
  null
  
)

export default component.exports